import util from '../util'

let controller = 'ContasReserva'
export default Object.assign({}, util.GetCrud(controller, null))